import React from 'react';

const GradeComponent = ({ score, type }) => {
	// Function to determine the letter grade
	const getLetterGrade = (score) => {
		if (type === 'helpdesk' || type === 'hiring') {
			if (score >= 150) {
				return 'A';
			} else if (score >= 100) {
				return 'B';
			} else if (score >= 50) {
				return 'C';
			} else if (score >= 25) {
				return 'D';
			} else {
				return 'F';
			}
		} else {
			if (score >= 90) {
				return 'A';
			} else if (score >= 80) {
				return 'B';
			} else if (score >= 70) {
				return 'C';
			} else if (score >= 60) {
				return 'D';
			} else {
				return 'F';
			}
		}

	};

	// Function to determine the grade sign (+/-)
	const getGradeSign = (score) => {
		if (score <= 60) {
			return '';
		} else if (score >= 100) {
			return '+';
		}
		if (score % 10 >= 7) {
			return '+';
		} else if (score % 10 <= 3) {
			return '-';
		} else {
			return '';
		}
	};

	// Function to determine the color based on the letter grade
	const getGradeColor = (letterGrade) => {
		switch (letterGrade) {
			case 'A':
				return '#4CAF50'; // Green
			case 'B':
				return '#2196F3'; // Blue
			case 'C':
				return '#FFEB3B'; // Yellow
			case 'D':
				return '#FF9800'; // Orange
			case 'F':
				return '#F44336'; // Red
			default:
				return '#000000'; // Black (default)
		}
	};

	const letterGrade = getLetterGrade(score);
	const gradeSign = getGradeSign(score);
	const gradeColor = getGradeColor(letterGrade);
	let displayScore = '';
	if (type === 'hiring' || type === 'helpdesk') {
		if (score >= 50) {
			score = score - 50;
			score = score / 5;
			if (score > 29.9) {
				score = 29.9
			}
			displayScore = 70 + ((Math.round(score * 10) / 10).toString().includes('.0') ? (Math.round(score * 10) / 10).toString().split('.')[0] : Math.round(score * 10) / 10)
		} else if (score >= 25) {
			score = score - 25;
			score = score / 2.5;
			displayScore = 60 + ((Math.round(score * 10) / 10).toString().includes('.0') ? (Math.round(score * 10) / 10).toString().split('.')[0] : Math.round(score * 10) / 10)
		} else {
			score = score / 2.5;
			displayScore = 50 + ((Math.round(score * 10) / 10).toString().includes('.0') ? (Math.round(score * 10) / 10).toString().split('.')[0] : Math.round(score * 10) / 10)
		}
	} else {
		displayScore = score >= 99.9 ? '99.9' : ((Math.round(score * 10) / 10).toString().includes('.0') ? (Math.round(score * 10) / 10).toString().split('.')[0] : Math.round(score * 10) / 10);
	}

	return (
		<div style={{ color: gradeColor }}>
			<b>{letterGrade}{gradeSign}&nbsp;{displayScore}%</b>
		</div>
	);
};

export default GradeComponent;